import { DespesasFundoFixo } from '../_models';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AlertService } from './alert.service';
import {environment} from '../../environments/environment'


@Injectable({
    providedIn: 'root'
})

export class DespesasFundoFixoService {

    GetDespesasFundoFixo(empresa: string): Observable<any> {
        return this.http.get<DespesasFundoFixo[]>(`${environment.apiUrl}/api/DespesasFundoFixo?empresa=${empresa}`);
    }

    constructor(private http: HttpClient,
        private alertService: AlertService) { }


}
